"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_TREE = void 0;
const gql_1 = require("../../../../__generated__/gql");
// defer is not working for nested fragments
// the root node of the tree is not displayed, so there is no need to load counters
exports.GET_PRODUCT_TREE = (0, gql_1.gql)(`
  query productTree($nodeId: ID!, $catalogId: ID!) {
    productTreeNode(id: $nodeId) {
      ...ProductTreeNodeFragment
      children {
        ...ProductTreeNodeFragment
        ... @defer {
          ...ProductTreeNodePresentationsCountersFragment
        }
      }
    }
  }
`);
